import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';

import { BibliographicResourceTypeModule } from '®shared/bibliographic-resource';
import { EventsModule } from '®shared/events';
import { QuickFilterLabelModule } from '®shared/reading-list/quick-filters/quick-filter-label';
import { UriModule } from '®shared/url-utils';

import { ListAlertsComponent } from './list-alerts.component';

@NgModule({
  imports: [
    BibliographicResourceTypeModule,
    CommonModule,
    EventsModule,
    MomentModule,
    QuickFilterLabelModule,
    UriModule,
  ],
  declarations: [ListAlertsComponent],
  exports: [ListAlertsComponent],
})
export class ListAlertsModule {}
